// extracted by mini-css-extract-plugin
export default {"content":"fhZvhG","day":"OiEv9i","past":"Ay9zhG","dayText":"ymv7qf","today":"KEYpfd","events":"Jg7Ifi","event":"oVbK17"};